import { Command, HttpMethod } from "~/extensions/api";
export class FindBankBranchCommand extends Command {
    constructor() {
        super(HttpMethod.Get, "common/bank/branch/find");
    }
    bankCd = null;
    bankName = null;
    bansCd = null;
    bansName = null;
}
